"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _Modal = _interopRequireDefault(require("../../../common/Modal/Modal"));
var _MarginDepositFormContainer = _interopRequireDefault(require("./MarginDepositFormContainer"));
var _cssClassesHelper = require("../../../../helpers/cssClassesHelper");
require("./MarginDepositModalComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('margin-deposit-modal');
var MarginDepositModal = function MarginDepositModal(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('margin'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isOpen: props.isOpen,
    title: t('Deposit'),
    close: props.close,
    customClass: baseClasses()
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_MarginDepositFormContainer["default"], null)));
};
MarginDepositModal.propTypes = {};
var _default = exports["default"] = MarginDepositModal;